import { render, staticRenderFns } from "./ServiceLoginConsents.vue?vue&type=template&id=650e4c11"
import script from "./ServiceLoginConsents.vue?vue&type=script&lang=js"
export * from "./ServiceLoginConsents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports